import { makeAutoObservable } from "mobx";

class AppStore {
  sidebarOpen = true;

  constructor() {
    makeAutoObservable(this);
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
}

const appStore = new AppStore();
export default appStore;
